<script setup>
import Loading from '../../../Loading.vue';

/**
 * The chat panels' loading state is the hub's: a skeleton shaped like the
 * list that is coming, never a spinner (prototype "WAITING, WITHOUT A
 * SPINNER"). Kept as its own file so the chat components keep their imports;
 * `color` and `containerStyles` are accepted and have nothing left to style.
 */
defineOptions({ inheritAttrs: false });
defineProps({
  color: { type: String, default: null },
  size: { type: String, default: null },
  containerStyles: { type: Object, default: null },
});
</script>

<template>
  <Loading v-bind="$attrs" />
</template>
